import React, { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { TextField } from '@mui/material'
import moment from 'moment'

const PosthogFilterDropdown = ({filters, setFilters, onApply, handleResetFilters, activeTab}) => {

  const handleChange = (field, value) => {
    setFilters((prev) => {
      const updated = { ...prev, [field]: value };
      // If FromDate changes and ToDate is now before it, clear ToDate
      if (field === 'FromDate' && updated.ToDate && value && moment(updated.ToDate).isBefore(moment(value), 'day')) {
        updated.ToDate = null;
      }
      return updated;
    });
  };

  return (
    <div
      className="w-[350px] px-[30px] py-[20px] text-[#000000] font-Poppins"
      style={{
        background:
          'transparent linear-gradient(90deg, #FFFFFF 0%, #D6D8FF 100%) 0% 0% no-repeat padding-box',
        boxShadow: '4px 4px 6px #00000029',
        border: '2px solid #8774DC',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="w-full flex flex-col gap-[10px]">
        {/* Email */}
        {activeTab=== "Live Feed" &&  (
        <>
        <p className="text-[16px] font-semibold">Email</p>

        <input
          type="text"
          placeholder="Enter Email"
          value={filters.Email}
          onChange={(e) => handleChange('Email', e.target.value)}
          style={{
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
          paddingBottom: '4px',
          color: '#000000',
          fontSize: '16px',
          boxShadow: 'none',
        }}
        />
        </>
        )}

        {/* Country */}
        {activeTab=== "Country" &&  (
        <>
        <p className="text-[16px] font-semibold">Country</p>

        <input
          type="text"
          placeholder="Enter Country"
          value={filters.Country}
          onChange={(e) => handleChange('Country', e.target.value)}
          style={{
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
          paddingBottom: '4px',
          color: '#000000',
          fontSize: '16px',
          boxShadow: 'none',
        }}
        />
        </>
        )}

        {/* Email */}
        {activeTab=== "Country" &&  (
        <>
        <p className="text-[16px] font-semibold">City</p>

        <input
          type="text"
          placeholder="Enter City"
          value={filters.City}
          onChange={(e) => handleChange('City', e.target.value)}
          style={{
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
          paddingBottom: '4px',
          color: '#000000',
          fontSize: '16px',
          boxShadow: 'none',
        }}
        />
        </>
        )}

        {/* FromDate */}
        <p className="text-[16px] font-semibold">From Date</p>
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
            closeOnSelect={false}
            value={filters.FromDate || null}
            onChange={(newValue) => {
            if (newValue && moment(newValue).isValid()) {
                handleChange('FromDate', moment(newValue));
            } else {
                handleChange('FromDate', null);
            }
            }}
            format="DD/MM/YYYY"
            renderInput={(params) => (
                <TextField
                {...params}
                fullWidth
                sx={{
                    '& .MuiOutlinedInput-root': {
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 0px 6px #00000029',
                    border: '1px solid #E2E2E2',
                    opacity: 1,
                    '& fieldset': {
                        borderColor: '#E2E2E2',
                    },
                    '&:hover fieldset': {
                        borderColor: '#E2E2E2',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#E2E2E2',
                    },
                    },
                }}
                inputProps={{
                    ...params.inputProps,
                    readOnly: true,
                }}
                />
            )}
            />
        </LocalizationProvider>

        {/* To Date */}
        <p className="text-[16px] font-semibold">To Date</p>
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
            closeOnSelect={false}
            disabled={!filters.FromDate}              // ← disabled until From is picked
            minDate={filters.FromDate || undefined}   // ← can't pick before FromDate
            value={filters.ToDate || null}
            onChange={(newValue) => {
            if (newValue && moment(newValue).isValid()) {
                handleChange('ToDate', moment(newValue));
            } else {
                handleChange('ToDate', null);
            }
            }}
            format="DD/MM/YYYY"
            renderInput={(params) => (
                <TextField
                {...params}
                fullWidth
                sx={{
                    '& .MuiOutlinedInput-root': {
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 0px 6px #00000029',
                    border: '1px solid #E2E2E2',
                    opacity: 1,
                    '& fieldset': {
                        borderColor: '#E2E2E2',
                    },
                    '&:hover fieldset': {
                        borderColor: '#E2E2E2',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#E2E2E2',
                    },
                    },
                }}
                inputProps={{
                    ...params.inputProps,
                    readOnly: true,
                }}
                />
            )}
            />
        </LocalizationProvider>

        {/* Buttons */}
        <button
          className="w-full h-[49px] mt-2 py-2 text-white rounded font-Poppins text-[16px] cursor-pointer"
          style={{
            background: 'transparent linear-gradient(90deg, #8774DC 0%, #80D2F6 51%, #8776DD 100%) 0% 0% no-repeat padding-box',
            boxShadow: '0px 15px 30px #43425D1A'
          }}
          onClick={onApply} // <- trigger parent filter logic
        >
          <img
            src={
                  require("../Assets/searchIcon.svg")
                      .default
              }
            alt="search"
            className="absolute left-[50px] w-[20px] h-[20px]" // adjust size/margin if needed
          />
          Apply Filters
        </button>
        <p className="text-center text-[16px] text-[#A1A3EF] cursor-pointer" onClick={handleResetFilters}>Reset</p>
      </div>
    </div>
  );
};

export default PosthogFilterDropdown;
